import Debug from 'debug';
export const getTag = (path: string) => {
    return `aumico:aumico-lib-settings-fe:${path.replace(/^.*[\\\/]/, '')}`;
};
export const getDebug = (path: string) => {
    return Debug(getTag(path));
};

export const getTagTest = (path: string) => {
    return `aumico:tests:aumico-lib-settings-fe:${path.replace(/^.*[\\\/]/, '')}`;
};

export const getDebugTest = (path: string) => {
    return Debug(getTagTest(path));
};
